import { render, staticRenderFns } from "./NsSlottedDropdown.vue?vue&type=template&id=524c64ef&scoped=true&"
import script from "./NsSlottedDropdown.vue?vue&type=script&lang=js&"
export * from "./NsSlottedDropdown.vue?vue&type=script&lang=js&"
import style0 from "./NsSlottedDropdown.vue?vue&type=style&index=0&id=524c64ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524c64ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('524c64ef')) {
      api.createRecord('524c64ef', component.options)
    } else {
      api.reload('524c64ef', component.options)
    }
    module.hot.accept("./NsSlottedDropdown.vue?vue&type=template&id=524c64ef&scoped=true&", function () {
      api.rerender('524c64ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsSlottedDropdown.vue"
export default component.exports